import { memo, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import ChangeControlDataFormComponent from './change-control-data-form';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import {
  ChangeControlDataForm,
  RegistrationBewareFormVM,
} from 'mutation/view-models/registration-beware';

const ChangeControlDataAccordionComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(false);
  const formContext = useFormikContext<RegistrationBewareFormVM>();
  const { changeControlDataForm } = formContext.values;
  const errors: FormikErrors<ChangeControlDataForm> | undefined =
    formContext.errors.changeControlDataForm;
  const touched: FormikTouched<ChangeControlDataForm> | undefined =
    formContext.touched.changeControlDataForm;

  const handleFormFieldChange = useEventCallback(
    (
      key: keyof ChangeControlDataForm,
      value: ChangeControlDataForm[keyof ChangeControlDataForm]
    ) => {
      const newForm = {
        ...formContext.values.changeControlDataForm,
        [key]: value,
      };
      formContext.setFieldValue('changeControlDataForm', newForm);
    }
  );

  return (
    <Accordion expanded={open} onChange={() => setOpen((old) => !old)}>
      <AccordionSummary
        aria-controls="panel-change-control-data-content"
        id="panel-change-control-data-content"
        expandIcon={<ExpandMore />}
      >
        <Typography>Dati di controllo modifica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ChangeControlDataFormComponent
          errors={errors}
          changeControlDataForm={changeControlDataForm}
          touched={touched}
          handleFormFieldChange={handleFormFieldChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

ChangeControlDataAccordionComponent.displayName = 'Change control data accordion component';

const ChangeControlDataAccordion = memo(ChangeControlDataAccordionComponent);

export default ChangeControlDataAccordion;
